module.exports = __webpack_public_path__ + "img/logo_bc_std_transparent.0691d091.svg";